import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './MultiSelect.scss'
import SelectField from './SelectField'
import ConsultationsApiClient from '@services/Consultations'

const SelectSpecialityField = (props) => {
  const { t } = useTranslation()
  const [specialities, setSpecialities] = useState([])
  const { multi, placeholder } = props

  useEffect(() => {
    fetchSpecialities()
  }, [])

  const fetchSpecialities = async () => {
    try {
      const { data } = await ConsultationsApiClient.speciality.index({ per_page: 1000 })

      const orderSpecialitiesByName = data.sort((a, b) => (b.name < a.name ? 1 : -1))
      setSpecialities(orderSpecialitiesByName)
    } catch (e) {
      console.error('error')
    }
  }

  return (
    <SelectField
      {...props}
      placeholder={placeholder || `${multi ? t('Especialidades') : t('Especialidad')}`}
      options={specialities}
    />
  )
}
export default SelectSpecialityField
